/** Legs */
export const GET_LEGS = "GET_LEGS";
export const GET_LEGS_SUCCESS = "GET_LEGS_SUCCESS";
export const ADD_LEG = "ADD_LEG";
export const DELETE_LEG = "DELETE_LEG";
export const CANCEL_LEG = "CANCEL_LEG";
export const UN_CANCEL_LEG = "UN_CANCEL_LEG";
export const NO_SHOW_LEG = "NO_SHOW_LEG";
export const UN_NO_SHOW_LEG = "UN_NO_SHOW_LEG";
export const ACCEPT_PENDING_LEG = "ACCEPT_PENDING_LEG";
export const REJECT_PENDING_LEG = "REJECT_PENDING_LEG";
export const EDIT_LEG_LIST = "EDIT_LEG_LIST";

export const EDIT_TRIP = "EDIT_TRIP";
export const DELETE_TRIP = "DELETE_TRIP";
export const CANCEL_TRIP = "CANCEL_TRIP";
export const NEXT_PREV_TRIP = "NEXT_PREV_TRIP";
export const RECALCULATE_TRIP_REVENUE = "RECALCULATE_TRIP_REVENUE";
export const REFRESH_ALL_DATA = 'REFRESH_ALL_DATA'
export const UN_CANCEL_TRIP = "UN_CANCEL_TRIP";

export const GET_LEGS_TOTAL = "GET_LEGS_TOTAL";
export const GET_LEGS_TOTAL_SUCCESS = "GET_LEGS_TOTAL_SUCCESS";

export const LEG_ASSIGN_OR_CHANGE_DATA = "LEG_ASSIGN_OR_CHANGE_DATA";

/** CSV import */
export const LEG_CSV_IMPORT = "LEG_CSV_IMPORT";
export const LEG_CSV_IMPORT_SUCCESS = "LEG_CSV_IMPORT_SUCCESS";
/** End */

/** Repeat weekly */
export const REPEAT_WEEKLY = "REPEAT_WEEKLY";

/** Single TRIP */
export const GET_SINGLE_TRIP = "GET_SINGLE_TRIP";
export const GET_SINGLE_TRIP_SUCCESS = "GET_SINGLE_TRIP_SUCCESS";

/**create Leg Notes */
export const CREATE_LEG_NOTE = "CREATE_LEG_NOTE";

/**edit Leg Notes */
export const EDIT_LEG_NOTE = "EDIT_LEG_NOTE";

/**delete Leg Notes */
export const DELETE_LEG_NOTE = "DELETE_LEG_NOTE";

